(() => {
  const init = () => {
    const frame = document.querySelector('.ssb-policy-frame');
    const policy = document.querySelector('.ssb-shipping-policy .shopify-policy__container');
    const index = frame?.querySelector('[data-policy-index]');
    if (!frame || !policy || !index || frame.dataset.ready) return;
    frame.dataset.ready = 'true';
    frame.append(policy);
    const headings = policy.querySelectorAll('.shopify-policy__body h2');
    headings.forEach((heading, i) => {
      if (!heading.id) heading.id = `ssb-policy-section-${i + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.append(link);
      index.append(item);
    });
    if (headings.length) frame.querySelector('.ssb-policy-index').hidden = false;
    const body = policy.querySelector('.shopify-policy__body');
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode: node => node.parentElement.closest('a,strong,b,h1,h2,h3,script,style') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    const emphasis = /(SkinSwaag Beauty|physically in-stock|\$30 or more|confirmed appointment only|No walk-ins\.|within 15 minutes of purchase|before payment|unless clearly stated at checkout)/g;
    nodes.forEach(node => {
      const parts = node.textContent.split(emphasis);
      if (parts.length < 2) return;
      const fragment = document.createDocumentFragment();
      parts.forEach((part, i) => {
        if (i % 2) {
          const strong = document.createElement('strong');
          strong.textContent = part;
          if (part === 'SkinSwaag Beauty') strong.className = 'ssb-policy-brand-name';
          fragment.append(strong);
        } else fragment.append(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
